export enum MailingMessageTypeEnum {
  Unknown = 0,
  ReviewRequest = 1,
  GiftReminder = 2
}
